import { useLoadInfinite } from './general';

export const useGetAudiences = () => {
  return useLoadInfinite('audiences/', {});
};
